import { useState, useEffect } from 'react'

export type Language = 'en' | 'fr' | 'yo' | 'ig'

export const languages = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'yo', label: 'Yorùbá', flag: '🇳🇬' },
  { code: 'ig', label: 'Igbo', flag: '🇳🇬' },
] as const

export function useLanguage() {
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem('language')
    return (saved as Language) || 'en'
  })

  useEffect(() => {
    localStorage.setItem('language', language)
    document.documentElement.lang = language
  }, [language])

  const t = (key: string): string => {
    // In a real app, this would be a proper i18n implementation
    // For this demo, we'll just return the key or a mock translation
    return key
  }

  return { language, setLanguage, t }
}
